import { createFileRoute } from '@tanstack/react-router'
import { OrgConfigPage } from '@/components/settings/org-config-page'

export const Route = createFileRoute('/settings/$orgId')({
  component: SettingsOrg,
})

function SettingsOrg() {
  const { orgId } = Route.useParams()
  // key: fresh row state when switching organisations.
  return <OrgConfigPage key={orgId} orgId={orgId} />
}
